import { computed, inject, Injectable, signal } from '@angular/core';
import { GuidelineService } from 'shared/domain';

import { ComponentListType, ComponentListWidget, ComponentType, ComponentWidget } from '@treetop/shared/model';

@Injectable()
export class EditComponentListWidgetService {
  private guidelineService = inject(GuidelineService);

  private widget = signal<ComponentListWidget | undefined>(undefined);
  private searching = signal(false);

  private componentWidgets = computed(() => {
    return this.widget()?.widgetIds?.map((widgetId) => this.guidelineService.getWidget<ComponentWidget>(widgetId));
  });

  private allowedComponentTypes = computed(() => {
    switch (this.widget()?.componentListType) {
      case ComponentListType.Conditions:
        return [ComponentType.ConditionDefinition];
      case ComponentListType.DiagnosisPlan:
        return [ComponentType.ActivityDefinition];
      case ComponentListType.Criteria:
        return [ComponentType.FindingDefinition, ComponentType.ObservationDefinition];
      default:
        return [];
    }
  });

  public viewModel = computed(() => ({
    widget: this.widget(),
    componentWidgets: this.componentWidgets(),
    searching: this.searching(),
    allowedComponentTypes: this.allowedComponentTypes(),
  }));

  public setWidget(widget: ComponentListWidget): void {
    this.widget.set(widget);
  }
}
